import GenericMenuItem from './GenericMenuItem'
import { useGetIdentity, useTranslate } from 'react-admin'
import { TextFields } from "@mui/icons-material"

const UserTextModelMenu = () => {

  const translate = useTranslate()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <GenericMenuItem 
      title={translate('resources.textTemplates.name', {smart_count: 2})}
      link={`/users/${identity.id}/textModel`}
      icon={<TextFields />}
    />
  )
}

export default UserTextModelMenu